import styled from 'styled-components';

export const WeekDaySC = styled.div`
  .menu-open & {
    pointer-events: none;
  }

  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  border-right: 2px solid rgba(251, 251, 251, 0.8);

  &:last-child {
    border-right: 2px solid transparent;
  }

  .event-container {
    position: relative;
    z-index: 3;
    width: 95%;
  }

  .extra-event-container {
    position: relative;
    z-index: 4;
    width: 95%;
  }

  .container {
    position: relative;
    width: 100%;
  }

  .mark-container {
    z-index: 1;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`;

export const WeekDayItemSC = styled.div<{ zIndex: number; maxZIndex: number }>`
  .menu-open & {
    pointer-events: none;
  }

  z-index: ${({ zIndex }) => zIndex};
  transition: z-index 0.2s;

  &:hover {
    z-index: ${({ maxZIndex }) => maxZIndex};
    transition: z-index 0.2s;
  }
`;
